import { Schema } from "effect";
import {
  ConversationId,
  ConversationThreadId,
  DraftMessageId,
  MessageId,
} from "../../../ids/definitions";
import { MongoUserId } from "../../../ids/mongo-ids";
import { EmailRecipientSchema } from "./conversation";
import { Attachment } from "./message/attachment";

export const SaveDraftInput = Schema.Struct({
  threadId: ConversationThreadId,
  inReplyToMessageId: Schema.optional(MessageId),
  content: Schema.String,
  attachments: Schema.Array(Attachment),
  cc: Schema.optional(Schema.Array(EmailRecipientSchema)),
  bcc: Schema.optional(Schema.Array(EmailRecipientSchema)),
});

export type SaveDraftInput = typeof SaveDraftInput.Type;

export const DraftMessageStatus = Schema.Literal("PENDING", "SENDING", "ERROR");
export type DraftMessageStatus = typeof DraftMessageStatus.Type;

export const DraftResponse = Schema.Struct({
  id: DraftMessageId,
  conversationId: ConversationId,
  threadId: ConversationThreadId,
  inReplyToMessageId: Schema.OptionFromUndefinedOr(MessageId),
  senderMongoUserId: MongoUserId,
  content: Schema.String,
  attachments: Schema.Array(Attachment),
  cc: Schema.optional(Schema.Array(EmailRecipientSchema)),
  bcc: Schema.optional(Schema.Array(EmailRecipientSchema)),
  status: DraftMessageStatus,
  createdAt: Schema.DateTimeUtc,
  updatedAt: Schema.DateTimeUtc,
});

export type DraftResponse = typeof DraftResponse.Type;

export const ThreadDraftsResponse = Schema.Struct({
  drafts: Schema.Array(DraftResponse),
});

export type ThreadDraftsResponse = typeof ThreadDraftsResponse.Type;

const SendMessageInputNew = Schema.Struct({
  kind: Schema.Literal("new"),
  threadId: ConversationThreadId,
  content: Schema.String,
  draftId: DraftMessageId,
  attachments: Schema.Array(Attachment),
});

const SendMessageInputReply = Schema.Struct({
  kind: Schema.Literal("reply"),
  threadId: ConversationThreadId,
  content: Schema.String,
  draftId: Schema.optional(DraftMessageId),
  attachments: Schema.Array(Attachment),
  inReplyToMessageId: MessageId,
});

export const SendMessageInput = Schema.Union(
  SendMessageInputNew,
  SendMessageInputReply,
);

export type SendMessageInput = typeof SendMessageInput.Type;

export class NotImplementedError extends Schema.TaggedError<NotImplementedError>()(
  "NotImplementedError",
  { message: Schema.String },
) {}
